export default __webpack_public_path__ + "static/media/C0004.515e3aa8.png";